/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Cta_DescInputs */

const en_nfp_cta_desc = /** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the elite cohort of forward-thinking charities and religious organizations utilizing SSC to build deeper, authenticated connections.`)
};

const es_nfp_cta_desc = /** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a la cohorte de élite de organizaciones benéficas con visión de futuro que utilizan SSC para construir conexiones más profundas.`)
};

const fr_nfp_cta_desc = /** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoignez la cohorte d'élite des associations caritatives et religieuses avant-gardistes qui utilisent SSC pour établir des liens plus profonds et authentifiés.`)
};

const de_nfp_cta_desc = /** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließe dich der elitären Gruppe von zukunftsorientierten Wohltätigkeitsorganisationen an, die SSC nutzen.`)
};

const id_nfp_cta_desc = /** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bergabunglah dengan kelompok elit badan amal dan organisasi keagamaan berpemikiran maju yang memanfaatkan SSC untuk membangun koneksi yang diautentikasi dan lebih dalam.`)
};

/** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */
const ja_nfp_cta_desc = en_nfp_cta_desc;

/** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */
const zh_nfp_cta_desc = en_nfp_cta_desc;

/** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */
const ar_nfp_cta_desc = en_nfp_cta_desc;

/** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */
const it_nfp_cta_desc = en_nfp_cta_desc;

/** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */
const ru_nfp_cta_desc = en_nfp_cta_desc;

/** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */
const pt_nfp_cta_desc = en_nfp_cta_desc;

/** @type {(inputs: Nfp_Cta_DescInputs) => LocalizedString} */
const ko_nfp_cta_desc = en_nfp_cta_desc;

/**
* | output |
* | --- |
* | "Join the elite cohort of forward-thinking charities and religious organizations utilizing SSC to build deeper, authenticated connections." |
*
* @param {Nfp_Cta_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_cta_desc = /** @type {((inputs?: Nfp_Cta_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Cta_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_cta_desc(inputs)
	if (locale === "es") return es_nfp_cta_desc(inputs)
	if (locale === "fr") return fr_nfp_cta_desc(inputs)
	if (locale === "de") return de_nfp_cta_desc(inputs)
	if (locale === "ja") return ja_nfp_cta_desc(inputs)
	if (locale === "zh") return zh_nfp_cta_desc(inputs)
	if (locale === "ar") return ar_nfp_cta_desc(inputs)
	if (locale === "id") return id_nfp_cta_desc(inputs)
	if (locale === "it") return it_nfp_cta_desc(inputs)
	if (locale === "ru") return ru_nfp_cta_desc(inputs)
	if (locale === "pt") return pt_nfp_cta_desc(inputs)
	return ko_nfp_cta_desc(inputs)
});